import React, { Component } from 'react';
import { PerspectaModal } from './Modal';

export class ContextualHelpModal extends Component {

    static defaultProps = {
        title: 'Help',
        size: 'md',
        isOpen: false
    }

    constructor(props) {
        super(props);

        this.state = {
            isOpen: this.props.isOpen
        }
    }

    render() {
        return (
            <PerspectaModal
                environment={this.props.environment}
                isOpen={this.state.isOpen}
                title={this.props.title}
                size={this.props.size}
                onClose={this.handleClose}>
                <div className="padding-lg">
                    <p>{this.props.content}</p>
                </div>
            </PerspectaModal>
        );
    }

    handleClose = (e) => {
        this.setState({
            isOpen: false,
        }, () => {
            if (this.props.onClose) {
                // Delay close callback for animation to finish
                setTimeout(() => {
                    this.props.onClose();
                }, 200);
            }
        });
    }
}